import axios from "axios"

export default{
    async GetUserActionLogTable(data){
        const response = await axios.post('/api/log/get/table/useraction',data)
        return response
    },
    async GetActionLogLevels(data){
        const response = await axios.get('/api/log/get/actionloglevel',data)
        return response
    },
    async GetActionNames(data){
        const response = await axios.get('/api/log/get/actionname',data)
        return response
    },
}